import { Component, Input, OnInit } from '@angular/core';


@Component({
    selector: 'owner',
    templateUrl: './owner.component.html',
    styleUrls: ['./owner.component.scss']
})
export class OwnerComponent implements OnInit {

    @Input() info : any;

    constructor( 
    ){
    }
    
    ngOnInit(){

    }

}